import { bubEvents } from 'shared/events/bub_events';
import { giftCardUtils } from 'shared/utils/gift_card_utils';
import { SiteConversionTrackingHelper, SiteImpressions } from 'shared/events/site_conversion_tracking_helper';

$(document).ready(() => {
  const menuOpenToggle = $('.mobile-account-avatar-icon');
  const menuCloseToggle = $('.account-mobile-cancel');
  const menu = $('.account-overlay-wrapper');
  let menuOpen = false;

  if (menu) {
    const closeMenu = () => {
      menu.attr('aria-hidden', true);
      menuOpen = false;
      menu.removeClass('active');
      $('body').css('overflow', '');
    };

    const openMenu = () => {
      menuOpen = true;
      menu.attr('aria-hidden', false);
      giftCardUtils.viewBalance();
      menu.addClass('active');
      $('body').css('overflow', 'hidden');
    };

    $(menuOpenToggle).on('click touch', () => {
      if (!menuOpen) {
        openMenu();

        bubEvents.track('Header account', 'Clicked icon', {
          label: 'Account icon',
        });

        SiteImpressions.trackImmediately({
          category: 'Header account',
          action: 'Viewed button',
          eventLabel: 'Sign Up for Free!',
        });
      }
    });

    $(menuCloseToggle).on('click touch', () => {
      if (menuOpen) {
        closeMenu();

        bubEvents.track('Header account', 'Clicked icon', {
          label: 'Close icon',
        });
      }
    });
  }

  $('.account-overlay .logged-in-account .account-overlay-link').on('click touch', event => {
    bubEvents.track('Header account', 'Clicked link', {
      label: $(event.target).text(),
    });
  });

  $('.account-overlay .logged-out-account .sign-in-button').on('click touch', event => {
    bubEvents.track('Header account', 'Clicked button', {
      label: $(event.target).text(),
    });
  });

  $('.account-overlay .logged-out-account .sign-up-button').on('click touch', event => {
    bubEvents.track('Header account', 'Clicked button', {
      label: $(event.target).text(),
    });

    const signupTracker = new SiteConversionTrackingHelper('Header account overlay sign up link', event);
    signupTracker.trackConversion();
  });
});
